import { styled } from '@mui/system'
import { colors, fontSizes } from '../../../../Components/consts'

export const EvCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'space-around',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
}))

export const SelCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  margin: theme.spacing(1, 6),
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
    margin: theme.spacing(1, 3),
  },
}))

type CardParams = {
  participant: string
}

export const EventCardCon = styled('div')<CardParams>(({ participant, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: 356,
  height: 410,
  background: colors.offWhite,
  margin: theme.spacing(2),
  position: 'relative',
  borderRadius: 12,
  [theme.breakpoints.down('sm')]: {
    height: 'auto',
    minHeight: 380,
    margin: theme.spacing(2, 1),
  },
  '& .verifiedCon': {
    position: 'absolute',
    top: 5,
    left: 5,
    '& > div': {
      '& img': {
        width: 30,
        height: 30,
      },
      zIndex: 3,
    },
  },
  '& .imgCon': {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    background: colors.gray.gray20,
    borderRadius: `12px 12px 0 0`,
    '& > div': {
      '& img': {
        borderRadius: `12px 12px 0 0`,
        width: 356,
        height: 200,
      },
    },
  },
  '& .bothCon': {
    position: 'absolute',
    top: 180,
    left: 5,
    background: colors.gray.gray90,
    borderRadius: 10,
    padding: theme.spacing(0.5, 2),
    '& p': {
      fontSize: fontSizes.small,
      margin: 0,
      fontWeight: 700,
      color: colors.white,
    },
    zIndex: 3,
  },
  '& .shareCon': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    zIndex: 5
  },
  '& .infoCon': {
    position: 'relative',
    top: 195,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    margin: theme.spacing(-4, 2, 0),
    '& .upper': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      marginTop: theme.spacing(1),
      '& .date': {
        fontSize: fontSizes.medium,
        fontWeight: 600,
        color: colors.gray.gray80,
      },
      '& .location': {
        fontWeight: 600,
        fontSize: fontSizes.medium,
        color: colors.gray.gray80,
      },
    },
    '& .athCon': {
      '& p': {
        fontSize: fontSizes.small,
        color: colors.gray.gray80,
        margin: '8px 0 3px',
      },
      '& .athName': {
        fontWeight: 500,
        fontSize: fontSizes.medium,
        color: colors.gray.gray70,
      },
    },
  },
  '& a': {
    textDecoration: 'none',
    background: 'none',
    cursor: 'pointer',
    '& .bookingCon': {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: `0 0 12px 12px`,
      background: participant === 'Girls' ? colors.unleashed : colors.yellow,
      height: 45,
      cursor: 'pointer',
      border: 'none',
      color: participant === 'Girls' ? colors.white : colors.black,
      fontSize: fontSizes.medium,
      fontWeight: 800,
    },
  },
}))
